var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDisplay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 536 536",
    fill: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M 121 516 C 102 508 97 493 97 473 97 336 97 199 97 60 97 30 107 20 136 20 L 400 20 C 429 20 439 30 439 60 439 198 439 336 439 473 439 493 434 508 416 516 L 121 516 Z M 416 58 C 416 47 414 43 402 43 317 43 219 43 134 43 122 43 119 47 119 59 120 198 120 337 120 476 120 492 120 492 136 492 L 399 492 C 416 492 416 492 416 475 416 406 416 337 416 268 416 199 416 128 416 58 Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M 401 400 C 401 419 394 427 376 427 309 427 229 427 162 427 142 427 135 420 135 401 135 295 135 189 135 82 135 64 142 56 161 56 228 56 308 56 376 56 394 56 401 64 401 83 401 136 401 189 401 242 401 295 401 347 401 400 Z M 379 80 L 159 80 159 404 379 404 379 80 Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDisplay);
export default __webpack_public_path__ + "static/media/display.8e64bf40fd8b1efe20af39e0a28f4aba.svg";
export { ForwardRef as ReactComponent };